import React, { Fragment } from 'react';
import { Button, Form, Input, Label, Icon } from 'semantic-ui-react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { LibraryControlComponent } from '../../views/control_library/control_library_components';

import { getText } from '../../helpers'

function LibraryControlAsOption(props) {
  const { selectedLibraryControls, setAsSelectedControl, libraryControl } = props;
  const selectedClass = selectedLibraryControls.some(({ id }) => id === libraryControl.id) ? 'selected-control' : '';
  return (
    <div
      key={"control-" + libraryControl.id }
      className={'control-details library-control-details ' + selectedClass}
      onClick={()=>setAsSelectedControl(libraryControl)}
    >
      <LibraryControlComponent control={libraryControl} instanceConfig={props.instanceConfig} />
    </div>
  )
}

function LibraryControlsList(props) {
  return (
      <InfiniteScroll
        className="library-controls-list"
        dataLength={props.libraryControls.length}
        next={props.getMoreLibraryControls}
        hasMore={true}
        height={1}
      >
      <div className="library-controls-options">
        {
          props.libraryControls.map((libraryControl) => {
            return <LibraryControlAsOption
                      key={libraryControl.custom_id}
                      libraryControl={libraryControl}
                      selectedLibraryControls={props.selectedLibraryControls}
                      setAsSelectedControl={props.setAsSelectedControl}
                      instanceConfig={props.instanceConfig}
                    />
          })
        }
        {
          props.isfetchingLibraryControls &&
          <div className="loading-message">
            <i className="loading circle notched icon"></i>
            <span>{getText("Fetching library controls")}...</span>
          </div>
        }
        {
          !props.isfetchingLibraryControls && props.libraryControls.length === 0 &&
          <div className="no-result-message">
            <span>{getText("No library control was found.")}</span>
          </div>
        }
      </div>
    </InfiniteScroll>
  )
}

function LibraryControlSelector(props) {
  return (
    <div className="display-with-caption">
      <div>
        <Input
          className="search-library-control"
          fluid icon='search'
          placeholder={`${getText("Search controls")}...`}
          onChange={props.handleSearchChange}
        />
        <div className="selected-library-controls">
          <strong>{getText("Selected Controls")}:</strong>
          {props.selectedLibraryControls.map((control) => (
            <Label basic color="purple" size="medium" key={control.custom_id}>
              <strong>{control.custom_id}</strong>
              <Icon name='delete' onClick={() => props.setAsSelectedControl(control)}/>
            </Label>
          ))}
        </div>
      </div>
      <LibraryControlsList
        libraryControls={props.libraryControls}
        selectedLibraryControls={props.selectedLibraryControls}
        getMoreLibraryControls={props.getMoreLibraryControls}
        setAsSelectedControl={props.setAsSelectedControl}
        instanceConfig={props.instanceConfig}
        isfetchingLibraryControls={props.isfetchingLibraryControls}
      />
    </div>
  )
}

function ControlTypeButtons(props) {
  const { control, handleControlTypeChange } = props;
  return (
    <div>
      {
        control.is_library_control ?
        <Button.Group>
          <Button positive>{getText("Library Control")}</Button>
          <Button value='custom' onClick={handleControlTypeChange}>{getText("Custom Control")}</Button>
        </Button.Group>
      :
        <Button.Group>
          <Button value='library' onClick={handleControlTypeChange}>{getText("Library Control")}</Button>
          <Button positive>{getText("Custom Control")}</Button>
        </Button.Group>
      }
    </div>
  )
}

function CustomControlForm(props) {
  const { control, handleControlNameChange } = props;
  const controlNamePlaceholder = getText('Enter the control description');
  return (
    <Form className='custom-control-form'>
      <Form.Field fluid>
        <textarea id='control-name' name='name' placeholder={controlNamePlaceholder} defaultValue={control.name} onChange={handleControlNameChange}/>
      </Form.Field>
    </Form>
  )
}

export function CreateControlModalContent(props) {
  const { control, instanceConfig, isfetchingLibraryControls } = props;
  const recipients = ['Jose.Pasten@teck.com'];
  const subject = `Teck Exploration - Risk Mapper - ${getText('Library Control Suggestion')}`;
  return (
    <div className='display-with-caption'>
      <ControlTypeButtons
        control={control}
        handleControlTypeChange={props.handleControlTypeChange}
      />
      { 
        control.is_library_control ?
        <LibraryControlSelector
          libraryControls={props.libraryControls}
          selectedLibraryControls={props.selectedLibraryControls}
          handleSearchChange={props.handleSearchChange}
          getMoreLibraryControls={props.getMoreLibraryControls}
          setAsSelectedControl={props.setAsSelectedControl}
          instanceConfig={instanceConfig}
          isfetchingLibraryControls={isfetchingLibraryControls}
        /> 
        :
        <Fragment>
          <CustomControlForm
            control={control}
            handleControlNameChange={props.handleControlNameChange}
          />
          <div>
            <span><strong>{getText('Note')}</strong>: </span>
            <span>{getText('If you want to add this custom control to the control library, please send an email to')} </span>
            <span>
              {
                recipients.map((email, index)=>{
                  return (
                    <Fragment>
                      <a href={`mailto:${email}?subject=${subject}`}><u><b>{email}</b></u></a>
                      { index < recipients.length - 1 && <span> or </span> }
                      { index === recipients.length - 1 && <span>.</span> }
                    </Fragment>
                  )
                })
              }
            </span>
            <br/>
            <span>{getText('Make the subject as')} '<strong>{subject}</strong>'.</span>
          </div>
        </Fragment>
        
      }
    </div>
  )
}

export function CreateControlModalActions(props) {
  const { disableSave, hideCreateControl, onSaveControl } = props;
  return (
    <div className="create-control-buttons">
      <Button size='medium' className="cancel-create-button" onClick={hideCreateControl}>
        {getText("Cancel")}
      </Button>
      <Button positive size='medium' className="save-control-button" onClick={onSaveControl} disabled={disableSave}>
        {getText("Save")}
      </Button>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/controls_component/create_control_components.js